import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';

const ProgressBar = ({ achieved, isCurrent }) => {
    const [mounted, setMounted] = useState(false);
    useEffect(() => {
        const id = requestAnimationFrame(() => setMounted(true));
        return () => cancelAnimationFrame(id);
    }, []);
    return (jsx("div", { className: "flex-1 rounded-full bg-neutral-100 overflow-hidden", children: jsx("div", { className: `h-full rounded-full ${achieved && 'bg-button-bg-primary-default'}`, style: {
                width: mounted && achieved ? '100%' : '0%',
                transition: isCurrent && mounted ? 'width 400ms ease' : undefined,
            } }) }));
};

export { ProgressBar };
